export const GOOGLE_FORM = '/forms/d/e/1FAIpQLScBr1ijnDZOCoDOqL0tymep6-lUOn96VpLJwVTAxKqKtOghIg/formResponse';
export const GOOGLE_FORM_URL = `https://docs.google.com${GOOGLE_FORM}`;

export const GOOGLE_MEET = 'https://meet.google.com/ecr-ohok-ude';
